import { makeStyles } from '@material-ui/core/styles'

export const useFilterSelectorStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    marginBottom: 4,
    marginTop: 4,
  },
  filterContainer: {
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
  },
  filterCard: {
    padding: 0,
    margin: '4px 1px 4px 1px',
    whiteSpace: 'nowrap',
    color: theme.palette.primary.headerText,
    backgroundColor: theme.palette.paper.dragAndDrop,
    '&:hover': {
      color: theme.palette.primary.headerText,
      backgroundColor: theme.palette.paper.dragAndDrop,
    },
  },
  filterCardSelected: {
    padding: 0,
    margin: '4px 1px 4px 1px',
    backgroundColor: theme.color.rutgersRed,
    color: theme.color.white,
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: theme.color.rutgersRed,
      color: theme.color.white,
    },
  },
  filterCardText: {
    textTransform: 'capitalize',
    padding: '5px',
  },
  imageListItem: { height: 'auto', width: 'auto', margin: '0 2px 0 2px' },
  // filterButton: {
  //   padding: 0,
  // },
}))

export default useFilterSelectorStyles
